// extracted by mini-css-extract-plugin
export default {"dataGrid":"dataGrid_dataGrid__YPY8t","dataValue":"dataGrid_dataValue__C5tzX"};